import { AuthenticationRequest } from '~/common/entities/Authentication/AuthenticationRequest';
import {
  Button,
  Heading,
  InputField,
} from '~/common/components/defaultUIComponents';
import { useAuthenticationService } from '~/common/services/AuthenticationService';
import { Link } from '~/common/components/defaultUIComponents/Link';
import { Box, Center, Flex, useToast } from '@chakra-ui/react';
import { Login } from '~/common/components/icons/Login';
import { FormikProvider, useFormik } from 'formik';

function Authenticate() {
  const { login } = useAuthenticationService();
  const toast = useToast();

  const errorCB = () => {
    toast({
      title: 'Loginfehler',
      description:
        'Diese Kombination aus Benutzername & Passwort ist uns nicht bekannt.',
      duration: 5000,
      isClosable: true,
      status: 'error',
    });
  };

  const form = useFormik({
    initialValues: {
      username: '',
      password: '',
    } as AuthenticationRequest,
    onSubmit: login(undefined, errorCB),
  });

  return (
    <Center>
      <FormikProvider value={form}>
        <form id="form" onSubmit={form.handleSubmit}>
          <Heading m="auto" textAlign="center">
            authenticate.heading
          </Heading>
          <Flex mt={4} w="100%">
            <Login m="auto" boxSize="3em" />
          </Flex>
          <Box mt={4}>
            <InputField
              name="username"
              label="authenticate.username.label"
              placeholder="authenticate.username.placeholder"
              type="username"
              required
            />
          </Box>
          <Box mt={4}>
            <InputField
              name="password"
              label="authenticate.password.label"
              type="password"
              placeholder="authenticate.password.placeholder"
              required
            />
          </Box>
          <Flex mt={4}>
            <Button
              type="submit"
              colorScheme="green"
              isLoading={form.isSubmitting}
              mt={4}
              w="100%"
            >
              authenticate.submit.text
            </Button>
          </Flex>
          <Flex mt={4} justifyContent="end">
            <Link href="https://its4-plan.de/company/forgot_password">
              authenticate.forgot.password
            </Link>
          </Flex>
        </form>
      </FormikProvider>
    </Center>
  );
}

export default Authenticate;
